export class PqrMailPersonEntity{
    id:number;
    mailId:number;
    personId:number;

    constructor(){}
}